export const VOLUME_CALCULATION_MESSAGE = {
  Generic: 'Something Went Wrong.',
  HeapFullyOutOfDemBounds: 'Heap is completely outside DEM bounds.',
  HeapFullyOutOfBaseDemBounds: 'Heap is completely outside Base DEM bounds.',
  HeapPartiallyOutOfDemBounds: 'Heap is partially outside DEM bounds.',
  HeapPartiallyOutOfBaseDemBounds: 'Heap is partially outside Base DEM bounds.',
  HeapHasNoValidDemData: 'Heap covers no valid DEM data.',
  InvalidPolygon: 'Heap must be a valid polygon.',
} as const;

const PARTIALLY_OUT_OF_DEM_BOUNDS_LEGEND =
  'Heap partially out of DEM bounds — calculation uses in-bound region only';

const FULLY_OUT_OF_DEM_BOUNDS_LEGEND =
  'Heap fully out of DEM bounds — no calculation';

// Legend text mapping.
export const HEAP_CALCULATION_LEGEND: Record<string, string> = {
  [VOLUME_CALCULATION_MESSAGE.Generic]:
    'Volume calculation failed due to an unexpected error',
  [VOLUME_CALCULATION_MESSAGE.HeapPartiallyOutOfDemBounds]:
    PARTIALLY_OUT_OF_DEM_BOUNDS_LEGEND,
  [VOLUME_CALCULATION_MESSAGE.HeapPartiallyOutOfBaseDemBounds]:
    PARTIALLY_OUT_OF_DEM_BOUNDS_LEGEND,
  [VOLUME_CALCULATION_MESSAGE.HeapFullyOutOfDemBounds]:
    FULLY_OUT_OF_DEM_BOUNDS_LEGEND,
  [VOLUME_CALCULATION_MESSAGE.HeapFullyOutOfBaseDemBounds]:
    FULLY_OUT_OF_DEM_BOUNDS_LEGEND,
  [VOLUME_CALCULATION_MESSAGE.HeapHasNoValidDemData]:
    'Heap covers no valid DEM data — volume reported as zero',
  [VOLUME_CALCULATION_MESSAGE.InvalidPolygon]:
    'Heap is not a valid polygon — no calculation',
};
